module.exports = __webpack_public_path__ + "static/media/storyboard_background.7dfac08d.jpg";